import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkVirtualScrollResizePatchDirective } from '../directives/cdk-virtual-scroll-resize-patch.directive';

const modules = [
  MatIconModule,
  MatButtonModule,
  MatListModule,
  MatInputModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatTabsModule,
  MatToolbarModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatMenuModule,
  MatDialogModule,
  MatSnackBarModule,
  PortalModule,
  ScrollingModule,
  MatExpansionModule,
  MatCardModule,
  MatButtonToggleModule,
  MatFormFieldModule,
  MatSelectModule,
  MatOptionModule,
  MatDividerModule,
];

const declarations = [
  CdkVirtualScrollResizePatchDirective,
];

@NgModule({
  declarations: [
    ...declarations,
  ],
  imports: [
    ...modules,
  ],
  exports: [
    ...modules,
    ...declarations,
  ],
})
export class MaterialModule { }
